import { cn } from "@workspace/frontend-ui";

type Props = {
  thumbnailUrls: string[];
};

const cardClassName =
  "absolute top-1 left-1/2 h-8.5 w-6.5 rounded-[3px] object-cover";

const HeroThumbStack: FC<Props> = ({ thumbnailUrls }) => {
  const [center, left, right] = thumbnailUrls;

  if (!center) {
    return null;
  }

  return (
    <span aria-hidden="true" className="relative h-10 w-14.5 shrink-0">
      {left && (
        <img
          src={left}
          alt=""
          loading="lazy"
          className={cn(
            cardClassName,
            "-translate-x-[calc(50%+13px)] -rotate-15",
          )}
        />
      )}
      {right && (
        <img
          src={right}
          alt=""
          loading="lazy"
          className={cn(
            cardClassName,
            "translate-x-[calc(-50%+13px)] rotate-15",
          )}
        />
      )}
      <img
        src={center}
        alt=""
        loading="lazy"
        className={cn(
          cardClassName,
          "top-px h-8.75 -translate-x-1/2 shadow-[0_0_7px_3.5px_rgba(21,24,27,0.48)]",
        )}
      />
    </span>
  );
};

export default HeroThumbStack;
